import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel, faCalendarDay, faBell } from "@fortawesome/free-solid-svg-icons";
import "./managerheader.css";

export default function ManagerHeader() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const name = localStorage.getItem("ai2_name") || "Manager";

  const datePart = now.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const timePart = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const hour = now.getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  return (
    <div className="mh-root">
      <div className="mh-left">
        <div className="mh-icon-wrap">
          <FontAwesomeIcon icon={faHotel} className="mh-hotel-icon" />
        </div>
        <div>
          <p className="mh-greeting">{greeting}, {name}</p>
          <h1 className="mh-title">Manager Overview</h1>
        </div>
      </div>

      <div className="mh-right">
        <div className="mh-datetime">
          <FontAwesomeIcon icon={faCalendarDay} className="mh-dt-icon" />
          <span className="mh-date">{datePart}</span>
          <span className="mh-sep">·</span>
          <span className="mh-time">{timePart}</span>
        </div>
        <button className="mh-notif-btn" aria-label="Notifications">
          <FontAwesomeIcon icon={faBell} />
        </button>
      </div>
    </div>
  );
}
